module.exports = __webpack_public_path__ + "static/media/cc.59a1d9d9.png";